export default "__VITE_ASSET__7a50c518__"